import { containsNoCase } from './stringHelpers';

const MAX_DEPTH = 1;

function searchRecordByType(searchText: string, record: any, depth: number): Boolean {
  switch (typeof record) {
    case 'string':
      return containsNoCase(record, searchText);
    case 'number':
      return containsNoCase(record.toString(), searchText);
    case 'object':
      return record != null ? applySearchOnRecord(searchText, record, depth + 1) : false;
    default:
      return false;
  }
}

export function applySearchOnRecord(searchText: string, record: any, depth = 0): Boolean {
  if (depth > MAX_DEPTH) {
    return false;
  }
  const keys = Object.keys(record).filter(k => k !== 'relevanceSettings');
  return keys.some(k => searchRecordByType(searchText, record[k], depth));
}
